import type { ActiveEncodeMode, SessionStatus } from "@srd/shared";
import type { ViewerConnectionState } from "../webrtc/viewerSession";
import type { CompositorStats } from "../webrtc/tileCompositor";

export function SessionStatusBar(props: {
  sessionStatus: SessionStatus | string;
  connection: ViewerConnectionState;
  encodeMode: ActiveEncodeMode | null;
  stats: CompositorStats | null;
  hasVideoTrack: boolean;
}) {
  const bitrate =
    props.stats?.bitrateKbps != null ? `${props.stats.bitrateKbps} kbps` : "—";
  const fps = props.stats?.fps != null ? `${props.stats.fps} fps` : "—";

  return (
    <div className="status-bar" role="status">
      <span>
        Session: <strong>{props.sessionStatus}</strong>
      </span>
      <span>
        WebRTC: <strong>{props.connection}</strong>
      </span>
      <span>
        Encode: <strong>{props.encodeMode ?? "—"}</strong>
        {props.hasVideoTrack ? " (+H.264 track)" : ""}
      </span>
      <span>Bitrate: {bitrate}</span>
      <span>{fps}</span>
    </div>
  );
}
